exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".card--35Dur{display:flex;flex-direction:column;gap:24px}.title--1uXPG{font-size:20px;font-weight:700;margin:0 0 4px;color:#000}.statsRow--1_6MG{display:flex;gap:8px;justify-content:space-between;padding:0 24px;font-size:14px;font-weight:500;color:#202020;flex-wrap:wrap}.stat--1MlK8 span:first-child{font-weight:700;margin-right:4px}.summaryRow--1XExv{justify-content:space-between;padding:4px 24px}.collapseTrigger--2PyfV,.summaryRow--1XExv{display:flex;align-items:center}.collapseTrigger--2PyfV{gap:8px;font-size:14px;font-weight:500;cursor:pointer;color:#202020;background:none;border:none;padding:0}.collapseTrigger--2PyfV .chevron--p_wdo{flex-shrink:0;transition:transform .2s}.collapseTrigger--2PyfV.open--32nvm .chevron--p_wdo{transform:rotate(180deg)}.totalPrice--EOTBc{display:flex;align-items:center;gap:4px;font-size:14px;font-weight:700;color:#202020;white-space:nowrap}", ""]);

// Exports
exports.locals = {
	"card": "card--35Dur",
	"title": "title--1uXPG",
	"statsRow": "statsRow--1_6MG",
	"stat": "stat--1MlK8",
	"summaryRow": "summaryRow--1XExv",
	"collapseTrigger": "collapseTrigger--2PyfV",
	"chevron": "chevron--p_wdo",
	"open": "open--32nvm",
	"totalPrice": "totalPrice--EOTBc"
};